import { useCallback, useRef } from "react"
import { BannerAtom } from "@/atoms/bannersState"
import { isStringEmpty } from "@/utils/helpers"
import { Link, Skeleton, Stack, Typography } from "@mui/material"

import Image from "next/image"
import ArrowRightIcon from "@/assets/icons/arrow-right.svg"
import useTrans from "@/hooks/useTrans"

const AdvertisementItem = (props: BannerAtom & { isHome?: boolean }) => {
  const { img_url, title, desc, link, btn_text, isHome } = props
  const trans = useTrans()
  const readMoreLinkRef = useRef<HTMLAnchorElement | null>(null)

  const handleClick = useCallback(() => {
    if (readMoreLinkRef.current) {
      readMoreLinkRef.current.click()
    }
  }, [])

  return (
    <Stack
      direction={{ xs: "column", sm: isHome ? "column" : "row" }}
      className='bg-white border border-solid border-secondary rounded-lg p-5 h-full'
      gap={2}
      onClick={handleClick}
    >
      {img_url ? (
        <Image
          className={`rounded-lg ${isHome ? "w-full h-[209px]" : "w-[179px] h-[99px] hidden sm:block"}`}
          src={img_url}
          alt={title ?? "ad-image"}
          width={isHome ? 308 : 179}
          height={isHome ? 209 : 99}
        />
      ) : (
        <Skeleton
          className={`rounded-lg ${isHome ? "w-full h-[209px]" : "w-[179px] h-[99px] hidden sm:block"}`}
          variant='rectangular'
        />
      )}

      <Stack gap={1}>
        <Typography className='font-bold text-base text-neutral-1000'>{title ?? trans.dashboard.ad.title}</Typography>
        <Typography
          className='text-neutral-600 text-wrap truncate text-sm line-clamp-2'
          component='div'
          dangerouslySetInnerHTML={{ __html: desc }}
        />
        {!isStringEmpty(btn_text) && (
          <Link
            ref={readMoreLinkRef}
            className='text-primary text-sm flex items-center gap-2 no-underline hover:text-primary/80'
            href={link}
            target='_blank'
          >
            <span>{btn_text}</span>
            <Image src={ArrowRightIcon} alt='open-icon' width={16} height={16} />
          </Link>
        )}
      </Stack>
    </Stack>
  )
}

export default AdvertisementItem
